import { render, staticRenderFns } from "./board-modal.vue?vue&type=template&id=747bf87d&"
import script from "./board-modal.vue?vue&type=script&lang=js&"
export * from "./board-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports